import 'css-chunksrc/client/pages/zonesPage/reportsPage/loader/styles.scss';export default {
  "reportsPage": "_reportsPage_145pw_1",
  "main": "_main_145pw_6",
  "section": "_section_145pw_13",
  "title": "_title_145pw_21",
  "reportsList": "_reportsList_145pw_27",
  "report": "_report_145pw_1"
};